import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { downVIcon, searchIcon } from "../../../../assets/icons";
import { useSelector } from "react-redux";
import { categoryData } from "../../../../../redux/slices/categorySlice";
import { queryToUrl, urlToQuery } from "../../../../helper/utils";
import { ProductsApiService } from "../../../../../service/website/productsApiService";
import { SearchLogService } from "../../../../../service/admin/searchLogService";
import { fetchToken } from "../../../../../lib/globalApiClient";
import { SearchAutocompleteService } from "../../../../../service/admin/searchAutocompleteService";
import SearchAutocomplete from "../../../../../component/library/SearchAutocomplete";
// Image cropping modal disabled (kept for future use)
// import ImageCropper from "../../../../component/library/imageCropper";

import "./style.css";

export default function SearchBar() {
  const [searchVal, setSearchVal] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedCategory, setSelectedCategory] = useState("global");
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState("");
  const [showCropper, setShowCropper] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [searchError, setSearchError] = useState("");
  const [isSkuSearching, setIsSkuSearching] = useState(false);
  // COMMENTED OUT: Hover dropdown functionality - now using direct click
  // const [showImageDropdown, setShowImageDropdown] = useState(false);
  // const [isDraggingOver, setIsDraggingOver] = useState(false);

  const inputRef = useRef("");
  const navigate = useNavigate();
  const categories = useSelector(categoryData);
  const location = useLocation();
  const fileInputRef = useRef(null);
  // COMMENTED OUT: Dropdown ref - not needed for direct click
  // const imageDropdownRef = useRef(null);

  // 🚫 Restricted alphabetical sequences (not whole words)
  const restrictedSequences = [
    "sex",
    "porn",
    "porno",
    "erotic",
    "nude",
    "nudity",
    "xxx",
    "vibrator",
    "dildo",
    "anal beads",
    "bondage",
    "bdsm",
    "fetish",
    "fetishwear",
    "kink",
    "spanking",
    "whip",
    "gag",
    "handcuffs",
    "lingerie",
    "thong",
    "panties",
    "masturbation",
    "sex doll",
    "orgasm",
    "ejaculation",
    "penis",
    "vagina",
    "cock",
    "pussy",
    "anal",
    "analog",
    "blowjob",
    "cum",
    "semen",
    "sperm",
    "escort",
    "prostitute",
    "hooker",
    "brothel",
    "hentai",
    "camgirl",
    "webcam sex",
    "stripper",
    "cigarette",
    "cigarettes",
    "cigar",
    "cigars",
    "cigarillo",
    "toy for men",
    "toy for mens",
    "toys for men",
    "toys for mens",
    "cigarillos",
    "tobacco",
    "nicotine",
    "vape",
    "vaping",
    "e-cigarette",
    "e-cig",
    "juul",
    "hookah",
    "shisha",
    "rolling paper",
    "blunt wrap",
    "chewing tobacco",
    "snuff",
    "snus",
    "smokeless tobacco",
    "menthol",
    "flavored tobacco",
    "ashtray",
    "lighter fluid",
    "alcohol",
    "liquor",
    "spirit",
    "vodka",
    "rum",
    "tequila",
    "whiskey",
    "whisky",
    "bourbon",
    "gin",
    "brandy",
    "cognac",
    "absinthe",
    "moonshine",
    "champagne",
    "wine",
    "beer",
    "lager",
    "ale",
    "stout",
    "hard cider",
    "sake",
    "soju",
    "everclear",
    "cannabis",
    "marijuana",
    "weed",
    "thc",
    "cbd",
    "hemp",
    "hashish",
    "hash",
    "blunt",
    "joint",
    "bong",
    "pipe",
    "cocaine",
    "crack",
    "heroin",
    "fentanyl",
    "meth",
    "methamphetamine",
    "lsd",
    "acid",
    "shrooms",
    "psilocybin",
    "ecstasy",
    "mdma",
    "ketamine",
    "opium",
    "morphine",
    "oxycodone",
    "hydrocodone",
    "xanax",
    "valium",
    "steroid",
    "testosterone",
    "anabolic",
    "adderall",
    "ritalin",
    "percocet",
    "vicodin",
    "gun",
    "firearm",
    "pistol",
    "revolver",
    "rifle",
    "shotgun",
    "assault rifle",
    "landmine",
    "dynamite",
    "explosives",
    "taser",
    "stun gun",
    "pepper spray",
    "mace",
    "baton",
    "sword",
    "katana",
    "machete",
    "dagger",
    "knife",
    "switchblade",
    "butterfly knife",
    "bayonet",
    "brass knuckles",
    "crossbow",
    "arrow",
    "nunchucks",
    "throwing star",
    "shuriken",
    "molotov",
    "IED",
    "explosive device",
    "cancer",
    "tumor",
    "diabetes",
    "insulin",
    "HIV",
    "AIDS",
    "covid",
    "coronavirus",
    "flu cure",
    "miracle cure",
    "treatment",
    "remedy",
    "reverse disease",
    "detox",
    "cleanse",
    "miracle pill",
    "weight loss pill",
    "fat burner",
    "appetite suppressant",
    "steroid cream",
    "testosterone booster",
    "growth hormone",
    "hgh",
    "anabolic stack",
    "erectile dysfunction cure",
    "viagra",
    "cialis",
    "levitra",
    "fertility cure",
    "infertility cure",
    "hair loss cure",
    "baldness cure",
    "miracle oil",
    "snake oil",
    "arthritis cure",
    "alzheimer cure",
    "parkinson cure",
    "hepatitis cure",
    "std cure",
    "syphilis cure",
    "gonorrhea cure",
    "chlamydia cure",
    "herpes cure",
    "ebola cure",
    "malaria cure",
    "tuberculosis cure",
    "poison",
    "toxin",
    "pesticide",
    "insecticide",
    "herbicide",
    "asbestos",
    "cyanide",
    "arsenic",
    "mercury",
    "lead",
    "uranium",
    "plutonium",
    "nuclear",
    "radioactive",
    "fireworks",
    "firecracker",
    "explosive powder",
    "gunpowder",
    "dry ice bomb",
    "ivory",
    "rhino horn",
    "tiger bone",
    "shark fin",
    "whale meat",
    "counterfeit",
    "replica",
    "knockoff",
    "pirated",
    "stolen",
    "unlicensed",
    "black tar",
    "smuggling",
    "trafficking",
    "nazi",
    "swastika",
    "hitler",
    "kkk",
    "ku klux klan",
    "skinhead",
    "white power",
    "neo-nazi",
    "fascist",
    "jihad",
    "isis",
    "al-qaeda",
    "taliban",
    "terrorist",
    "extremism",
    "hate speech",
    "lynching",
    "racial slur",
    "holocaust denial",
    "hate propaganda",
    "manifesto",
    "supremacist",
    "islamophobia",
    "antisemitic",
    "homophobic",
    "hate crime",
    "strip club",
    "lap dance",
    "escort service",
    "cam sex",
    "live sex",
    "orgy",
    "gangbang",
    "pegging",
    "anal plug",
    "butt plug",
    "sex swing",
    "sex machine",
    "lubricant",
    "lube",
    "adult film",
    "adult movie",
    "pornstar",
    "hardcore",
    "softcore",
    "fisting",
    "rimming",
    "incest",
    "stepmom",
    "stepdad",
    "teen porn",
    "barely legal",
    "cumshot",
    "deepthroat",
    "kamasutra",
    "sex chat",
    "phone sex",
    "peep show",
    "strip tease",
    "hotwife",
    "cuckold",
    "shemale",
    "tranny",
    "ladyboy",
    "blood and soil",
  ];

  const riskySingleWords = [
    "anal",
    "pipe",
    "joint",
    "weed",
    "gun",
    "acid",
    "steroid",
    "testosterone"
  ];

  const normalizeInput = (input) => {
    return input
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  };

  // ✅ Check if text contains restricted alphabetical sequences anywhere
  const containsRestrictedSequence = (query, sequences) => {
    if (!query || !Array.isArray(sequences) || sequences.length === 0) return false;
    const normalizedQuery = normalizeInput(query);
    return sequences.some((sequence) => {
      const normalizedSequence = String(sequence).toLowerCase().trim();
      if (!normalizedSequence) return false;
      return normalizedQuery.includes(normalizedSequence);
    });
  };

  // Image compression function for mobile devices - Universal compatibility
  const compressImage = (file, maxWidth = 1920, quality = 0.85) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          try {
            console.log('Image dimensions:', img.width + 'x' + img.height);

            const canvas = document.createElement('canvas');
            let width = img.width;
            let height = img.height;

            // Calculate new dimensions maintaining aspect ratio
            if (width > maxWidth || height > maxWidth) {
              if (width > height) {
                height = (height * maxWidth) / width;
                width = maxWidth;
              } else {
                width = (width * maxWidth) / height;
                height = maxWidth;
              }
            }

            console.log('Target dimensions:', Math.round(width) + 'x' + Math.round(height));

            canvas.width = Math.round(width);
            canvas.height = Math.round(height);

            const ctx = canvas.getContext('2d');
            if (!ctx) {
              console.warn('Canvas context not available, using original file');
              resolve(file);
              return;
            }

            // Use better image smoothing for quality
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';

            ctx.drawImage(img, 0, 0, width, height);

            // Try canvas.toBlob first (modern browsers)
            if (canvas.toBlob) {
              canvas.toBlob(
                (blob) => {
                  if (blob) {
                    // Try File constructor (modern browsers)
                    try {
                      const compressedFile = new File([blob], file.name, {
                        type: 'image/jpeg',
                        lastModified: Date.now()
                      });
                      resolve(compressedFile);
                    } catch (e) {
                      // Fallback: use blob directly with filename property
                      blob.name = file.name;
                      blob.lastModified = Date.now();
                      resolve(blob);
                    }
                  } else {
                    console.warn('Blob creation failed, using original file');
                    resolve(file);
                  }
                },
                'image/jpeg',
                quality
              );
            } else {
              // Fallback for older browsers: use toDataURL
              try {
                const dataUrl = canvas.toDataURL('image/jpeg', quality);
                // Convert data URL back to blob
                const byteString = atob(dataUrl.split(',')[1]);
                const mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0];
                const ab = new ArrayBuffer(byteString.length);
                const ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) {
                  ia[i] = byteString.charCodeAt(i);
                }
                const blob = new Blob([ab], { type: mimeString });
                blob.name = file.name;
                blob.lastModified = Date.now();
                resolve(blob);
              } catch (e) {
                console.warn('Canvas conversion failed, using original file:', e);
                resolve(file);
              }
            }
          } catch (error) {
            console.warn('Image compression failed, using original file:', error);
            resolve(file);
          }
        };
        img.onerror = (error) => {
          console.warn('Image load failed, using original file:', error);
          resolve(file);
        };
        img.src = e.target.result;
      };
      reader.onerror = (error) => {
        console.warn('FileReader failed, using original file:', error);
        resolve(file);
      };
      reader.readAsDataURL(file);
    });
  };

  const ensureJpegFile = async (file) => {
    if (!file) {
      return file;
    }

    let convertedFile = file;
    const needsMimeConversion = file.type !== "image/jpeg";

    if (needsMimeConversion) {
      console.log("🔄 Converting non-JPEG image to JPEG format...");
      try {
        const jpegResult = await compressImage(file);
        if (jpegResult && jpegResult.size > 0) {
          convertedFile = jpegResult;
        }
      } catch (conversionError) {
        console.warn("JPEG conversion failed, using original file:", conversionError);
        convertedFile = file;
      }
    }

    if (convertedFile.type !== "image/jpeg") {
      try {
        convertedFile = new File([convertedFile], convertedFile.name, {
          type: "image/jpeg",
          lastModified: convertedFile.lastModified || Date.now(),
        });
      } catch (forceTypeError) {
        console.warn("Failed to force JPEG mime type, using original file:", forceTypeError);
        convertedFile = file;
      }
    }

    if (!/\.jpe?g$/i.test(convertedFile.name || "")) {
      const baseName = String(file.name || "upload").replace(/\.[^.]+$/, "");
      const jpegName = `${baseName}.jpeg`;

      try {
        convertedFile = new File([convertedFile], jpegName, {
          type: "image/jpeg",
          lastModified: convertedFile.lastModified || Date.now(),
        });
      } catch (renameError) {
        console.warn("File rename to .jpeg failed, continuing with existing name:", renameError);
      }
    }

    console.log("✅ Image ready for upload as JPEG:", {
      name: convertedFile.name,
      size: convertedFile.size,
      type: convertedFile.type,
    });

    return convertedFile;
  };

  // Debug: Log categories data structure
  useEffect(() => {
    if (categories && categories.length > 0) {
      // console.log('Categories data structure:', categories[0]);
    }
  }, [categories]);

  useEffect(() => {
    try {
      const ali = searchParams?.get("ali");
      const search = searchParams?.get("search");

      // Only set search value from URL if it's a direct search, not from navigation
      if (search && !ali) {
        setSearchVal(decodeURIComponent(search));
      } else if (!search) {
        setSearchVal("");
      }
      // Don't update search box when navigating with ali parameter

      // When API returns 400, products page sets this; show error under search bar
      const restrictedError = sessionStorage.getItem('search_bar_restricted_error');
      if (restrictedError) {
        sessionStorage.removeItem('search_bar_restricted_error');
        setSearchError(restrictedError);
      } else {
        // After success, products page removes the key; clear the restricted error from UI
        const restrictedMessage = '⚠️ This search contains restricted content.';
        setSearchError((prev) => (prev === restrictedMessage ? '' : prev));
      }
    } catch (error) {
      console.error("Search bar useEffect error:", error);
    }
  }, [location.search]);

  // COMMENTED OUT: Close image dropdown when clicking outside (fallback for touch devices)
  // useEffect(() => {
  //   const handleClickOutside = (e) => {
  //     if (
  //       imageDropdownRef.current &&
  //       !imageDropdownRef.current.contains(e.target) &&
  //       !e.target.closest('.image-search-hover-wrapper')
  //     ) {
  //       setShowImageDropdown(false);
  //     }
  //   };
  //   if (showImageDropdown) {
  //     document.addEventListener('mousedown', handleClickOutside);
  //   }
  //   return () => document.removeEventListener('mousedown', handleClickOutside);
  // }, [showImageDropdown]);

  // COMMENTED OUT: Keep a stable ref to onImageSelected for the paste handler
  // const onImageSelectedRef = useRef(null);

  // COMMENTED OUT: Handle CTRL+V paste image into search — works when dropdown is open OR search input is focused
  // useEffect(() => {
  //   const handlePaste = async (e) => {
  //     const items = e.clipboardData?.items;
  //     if (!items) return;
  //     for (let i = 0; i < items.length; i++) {
  //       const item = items[i];
  //       if (item.type.startsWith('image/')) {
  //         e.preventDefault();
  //         e.stopPropagation();
  //         const file = item.getAsFile();
  //         if (file) {
  //           setShowImageDropdown(false);
  //           if (onImageSelectedRef.current) {
  //             onImageSelectedRef.current({ target: { files: [file], value: '' } });
  //           }
  //         }
  //         return;
  //       }
  //     }
  //   };
  //   document.addEventListener('paste', handlePaste);
  //   return () => document.removeEventListener('paste', handlePaste);
  // }, []);

  // COMMENTED OUT: Auto-open dropdown when user drags a file from desktop onto the page
  // useEffect(() => {
  //   let dragCounter = 0;

  //   const handleDragEnter = (e) => {
  //     e.preventDefault();
  //     dragCounter++;
  //     // Check if dragging files (not text/elements)
  //     if (e.dataTransfer?.types?.includes('Files')) {
  //       setShowImageDropdown(true);
  //     }
  //   };

  //   const handleDragLeave = (e) => {
  //     e.preventDefault();
  //     dragCounter--;
  //     // Only close when truly leaving the window (counter hits 0)
  //     if (dragCounter <= 0) {
  //       dragCounter = 0;
  //       // Small delay so the dropdown dropzone can catch the drag
  //       setTimeout(() => {
  //         // Don't close if mouse is over the dropdown
  //         if (!imageDropdownRef.current?.matches(':hover')) {
  //           setShowImageDropdown(false);
  //         }
  //       }, 100);
  //     }
  //   };

  //   const handleDragOver = (e) => {
  //     e.preventDefault(); // Required to allow drop
  //   };

  //   const handleDrop = (e) => {
  //     // Reset counter on drop
  //     dragCounter = 0;
  //     // Don't prevent default here — let the dropzone handler catch it
  //     // Only prevent if dropped outside the dropzone
  //     if (!e.target.closest('.image-search-dropzone')) {
  //       e.preventDefault();
  //       setShowImageDropdown(false);
  //     }
  //   };

  //   document.addEventListener('dragenter', handleDragEnter);
  //   document.addEventListener('dragleave', handleDragLeave);
  //   document.addEventListener('dragover', handleDragOver);
  //   document.addEventListener('drop', handleDrop);

  //   return () => {
  //     document.removeEventListener('dragenter', handleDragEnter);
  //     document.removeEventListener('dragleave', handleDragLeave);
  //     document.removeEventListener('dragover', handleDragOver);
  //     document.removeEventListener('drop', handleDrop);
  //   };
  // }, []);

  const handleActiveInput = () => {
    if (inputRef.current && typeof inputRef.current.focus === "function") {
      inputRef.current.focus();
    }
  };
  const handleOnChange = (e) => {
    if (e.target.value) setSearchError("");
    setSearchVal(e.target.value);
  };

  const selectCategory = (e) => {
    try {
      setSelectedCategory(e.target.value);
    } catch (error) {
      console.error('Category selection error:', error);
      setSelectedCategory("global");
    }
  };

  // ✅ NEW: Abstracted core search execution logic
  const executeSearch = (searchTerm) => {
    // Force close keyboard on mobile devices immediately
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }
	

    // ✅ Check for restricted alphabetical sequences ANYWHERE in the query
    // if (containsRestrictedSequence(query, restrictedSequences)) {
    //   setSearchError("⚠️ This search contains restricted content.");

    //   // Create popup for visual feedback
    //   if (!document.getElementById("restricted-popup-style")) {
    //     const style = document.createElement("style");
    //     style.id = "restricted-popup-style";
    //     style.innerHTML = `
    //       .restricted-popup {
    //         position: fixed;
    //         left: 50%;
    //         top: 20%;
    //         transform: translateX(-50%);
    //         background: #fff;
    //         border-radius: 8px;
    //         padding: 12px 16px;
    //         box-shadow: 0 10px 30px rgba(0,0,0,0.15);
    //         z-index: 99999;
    //         transition: opacity .3s ease, transform .3s ease;
    //         opacity: 0;
    //         pointer-events: none;
    //       }
    //       .restricted-popup.show { opacity: 1; transform: translateX(-50%) translateY(0); pointer-events: auto; }
    //       .restricted-popup-content { font-size: 14px; color: #222; }
    //       .restricted-progress { width: 160px; height: 6px; background: #eee; border-radius: 3px; overflow: hidden; margin-top:8px; }
    //       .restricted-progress-bar { width: 100%; height: 100%; background: #f97316; transition: width 2.8s linear; }
    //     `;
    //     document.head.appendChild(style);
    //   }

    //   const popup = document.createElement("div");
    //   popup.className = "restricted-popup";
    //   popup.innerHTML = `
    //     <div class="restricted-popup-content">
    //       🚫 Search contains restricted content.
    //       <div class="restricted-progress"><div class="restricted-progress-bar"></div></div>
    //     </div>
    //   `;
    //   document.body.appendChild(popup);
    //   // show it
    //   setTimeout(() => popup.classList.add("show"), 30);
    //   // animate progress to 0
    //   setTimeout(() => {
    //     const bar = popup.querySelector(".restricted-progress-bar");
    //     if (bar) bar.style.width = "0%";
    //   }, 50);
    //   // remove
    //   setTimeout(() => {
    //     popup.classList.remove("show");
    //     setTimeout(() => popup.remove(), 300);
    //   }, 3000);

    //   return; // stop search
    // }

    try {
      const trimmed = String(searchTerm || "").trim();
	  
	  if (!trimmed) return;

      // FAST SKU SEARCH: Check if input looks like SKU and navigate directly to PDP
      // This happens FIRST before any other search to make it fast
      // if (looksLikeSku(trimmed)) {
      //   setIsSkuSearching(true);
      //   setSearchError("");

      //   // Try regular product SKU first (fast local DB)
      //   try {
      //     const skuResult = await ProductsApiService.getProductBySku(trimmed);
      //     if (skuResult && skuResult.status && skuResult.status.code === 200 && skuResult.data) {
      //       const product = skuResult.data;
      //       setIsSkuSearching(false);
      //       // Navigate directly to product details page
      //       if (product._id) {
      //         navigate(`/product-details/?id=${product._id}`);
      //         return;
      //       }
      //     }
      //   } catch (skuError) {
      //     // Regular product not found, continue to try Alibaba
      //   }

      //   setIsSkuSearching(false);
      //   // Try Alibaba product by offerId (if regular product not found)
      //   // Navigate directly to Alibaba PDP - the page will fetch details
      //   // This is faster than waiting for API response
      //   navigate(`/product-details/?ali=1&offer=${encodeURIComponent(trimmed)}`);
      //   return;
      // }

      // Special case: Global keyword search
      // IMPORTANT: use `searchTerm` (the selected suggestion) rather than `searchVal` (may be stale due to async state updates).
      if (selectedCategory === "global" && trimmed) {
        const payload = {
          keyword: trimmed,
          beginPage: 1,
          pageSize: parseInt(process.env.REACT_APP_TOTAL_PRODUCTS || '12', 10),
          country: "en",
        };

        // Store the search payload in session storage for the products page to use
        sessionStorage.setItem('alibaba_keyword_search', JSON.stringify(payload));



        // Navigate immediately to trigger the search with exact URL format
        const searchUrl = `/collection?ali=keyword&search=${encodeURIComponent(trimmed)}&category=global`;
        console.log('Navigating to Global search:', searchUrl);
        navigate(searchUrl);
        // Keep search term in input for user reference
        return;
      }

      // Special case: Global image search within website results
      // Example: img:https://example.com/photo.jpg
      // const trimmed = String(searchVal || "").trim();
      if (/^img:\s*/i.test(trimmed)) {
        const url = trimmed.replace(/^img:\s*/i, "");
        navigate(`/collection?ali=url&img=${encodeURIComponent(url)}`);
        return;
      }

      // Regular search - navigate immediately instead of setting query state
      let searchQuery = "";
      if (trimmed && selectedCategory !== "All Categories") {
        searchQuery = `?category=${queryToUrl(selectedCategory)}&search=${queryToUrl(trimmed)}`;
      } else if (trimmed && selectedCategory === "All Categories") {
        searchQuery = `?search=${queryToUrl(trimmed)}`;
      } else if (!trimmed && selectedCategory !== "All Categories") {
        searchQuery = `?category=${queryToUrl(selectedCategory)}`;
      }

      if (searchQuery) {
        console.log('Navigating to search:', `/collection${searchQuery}`);
        navigate(`/collection${searchQuery}`);
      }
    } catch (error) {
      console.error('Search error:', error);
      // Do not redirect to /collection on error - stay on current page
    }
  };
  
    // Wrapper for standard form submission (e.g., clicking the search button)
  const handleProducts = async (e) => {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }
    executeSearch(searchVal);
  };

  // COMMENTED OUT: Show/hide image search dropdown on hover - Now using direct click instead
  // const hoverTimeoutRef = useRef(null);
  // const handleImageSearchMouseEnter = () => {
  //   clearTimeout(hoverTimeoutRef.current);
  //   setShowImageDropdown(true);
  // };
  // const handleImageSearchMouseLeave = () => {
  //   hoverTimeoutRef.current = setTimeout(() => {
  //     setShowImageDropdown(false);
  //   }, 200);
  // };
  // const handleDropdownMouseEnter = () => {
  //   clearTimeout(hoverTimeoutRef.current);
  // };
  // const handleDropdownMouseLeave = () => {
  //   hoverTimeoutRef.current = setTimeout(() => {
  //     setShowImageDropdown(false);
  //   }, 200);
  // };

  // COMMENTED OUT: Trigger file input from the dropdown "Upload a photo" button
  // const handleUploadFromDropdown = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   setShowImageDropdown(false);

  //   if (!fileInputRef.current) {
  //     setSearchError('File upload is not ready. Please refresh the page.');
  //     return;
  //   }

  //   const input = fileInputRef.current;
  //   try {
  //     const originalStyles = {
  //       position: input.style.position,
  //       left: input.style.left,
  //       top: input.style.top,
  //       width: input.style.width,
  //       height: input.style.height,
  //       opacity: input.style.opacity,
  //       zIndex: input.style.zIndex,
  //       visibility: input.style.visibility
  //     };

  //     input.style.position = 'fixed';
  //     input.style.top = '50%';
  //     input.style.left = '50%';
  //     input.style.transform = 'translate(-50%, -50%)';
  //     input.style.width = '1px';
  //     input.style.height = '1px';
  //     input.style.opacity = '0.01';
  //     input.style.zIndex = '9999';
  //     input.style.visibility = 'visible';

  //     setTimeout(() => {
  //       try {
  //         input.focus();
  //         input.click();
  //         setTimeout(() => {
  //           Object.keys(originalStyles).forEach(key => {
  //             input.style[key] = originalStyles[key];
  //           });
  //         }, 150);
  //       } catch (clickError) {
  //         Object.keys(originalStyles).forEach(key => {
  //           input.style[key] = originalStyles[key];
  //         });
  //         setSearchError('Unable to open file picker. Please try again.');
  //       }
  //     }, 10);
  //   } catch (error) {
  //     setSearchError('Unable to open file picker. Please try again.');
  //   }
  // };

  // COMMENTED OUT: Handle drag-and-drop on the dropdown
  // const handleDropzoneDragOver = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   setIsDraggingOver(true);
  // };
  // const handleDropzoneDragLeave = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   setIsDraggingOver(false);
  // };
  // const handleDropzoneDrop = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   setIsDraggingOver(false);
  //   setShowImageDropdown(false);
  //   const file = e.dataTransfer?.files?.[0];
  //   if (file && file.type.startsWith('image/')) {
  //     if (onImageSelectedRef.current) {
  //       onImageSelectedRef.current({ target: { files: [file], value: '' } });
  //     }
  //   } else {
  //     setSearchError('Please drop a valid image file.');
  //   }
  // };

  // Global image upload search - Universal device compatibility (Direct click handler)
  const handleImageSearchClick = (e) => {
    console.log('=== Image Search Button Clicked ===');
    console.log('Event type:', e.type);
    console.log('User agent:', navigator.userAgent);

    // Prevent default button behavior
    e.preventDefault();
    e.stopPropagation();

    if (!fileInputRef.current) {
      console.error('File input ref is not available');
      setSearchError('File upload is not ready. Please refresh the page.');
      return;
    }

    const input = fileInputRef.current;
    try {
      const originalStyles = {
        position: input.style.position,
        left: input.style.left,
        top: input.style.top,
        width: input.style.width,
        height: input.style.height,
        opacity: input.style.opacity,
        zIndex: input.style.zIndex,
        visibility: input.style.visibility
      };

      input.style.position = 'fixed';
      input.style.top = '50%';
      input.style.left = '50%';
      input.style.transform = 'translate(-50%, -50%)';
      input.style.width = '1px';
      input.style.height = '1px';
      input.style.opacity = '0.01';
      input.style.zIndex = '9999';
      input.style.visibility = 'visible';

      setTimeout(() => {
        try {
          input.focus();
          input.click();
          setTimeout(() => {
            Object.keys(originalStyles).forEach(key => {
              input.style[key] = originalStyles[key];
            });
          }, 150);
        } catch (clickError) {
          Object.keys(originalStyles).forEach(key => {
            input.style[key] = originalStyles[key];
          });
          setSearchError('Unable to open file picker. Please try again.');
        }
      }, 10);
    } catch (error) {
      setSearchError('Unable to open file picker. Please try again.');
    }
  };

  const onImageSelected = async (e) => {
    const file = e.target.files?.[0];
    if (!file) {
      console.log('No file selected');
      return;
    }

    console.log('Image file selected:', {
      name: file.name,
      size: file.size,
      type: file.type
    });

    // Validate file type
    if (!file.type.startsWith('image/')) {
      setSearchError('Please select a valid image file');
      e.target.value = '';
      return;
    }

    // Check file size (max 10MB for mobile compatibility)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      setSearchError('Image is too large. Please select an image smaller than 10MB.');
      e.target.value = '';
      return;
    }

    // Clear any previous errors
    setSearchError('');

    // Clear the file input so the same file can be selected again
    e.target.value = '';

    try {
      console.log('=== Starting Image Processing ===');
      console.log('File details:', {
        name: file.name,
        size: file.size,
        type: file.type,
        lastModified: file.lastModified
      });

      // Detect if running on mobile device
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const isCameraPhoto = file.name.match(/^(IMG_|image_|Photo|DCIM|Camera)/i) ||
        (isMobile && Date.now() - file.lastModified < 60000); // Photo taken in last minute

      console.log('Device type:', isMobile ? 'Mobile' : 'Desktop');
      console.log('Likely camera photo:', isCameraPhoto ? 'Yes' : 'No');

      // For mobile/camera: ALWAYS optimize images for better search results
      let processedFile = file;
      let shouldCompress = false;
      let targetWidth = 1920;
      let targetQuality = 0.85;

      // Determine compression settings based on source
      if (isCameraPhoto || isMobile) {
        // Mobile camera photos: Always compress for better search accuracy
        shouldCompress = true;
        targetWidth = 1280; // Lower resolution for better API processing
        targetQuality = 0.78; // Slightly lower quality
        console.log('📸 Camera/Mobile photo detected - will optimize for search');
      } else if (file.size > 2 * 1024 * 1024) {
        // Large desktop images: Standard compression
        shouldCompress = true;
        targetWidth = 1920;
        targetQuality = 0.85;
        console.log('💾 Large image detected - will compress');
      } else if (file.size > 500 * 1024) {
        // Medium images: Light optimization
        shouldCompress = true;
        targetWidth = 1600;
        targetQuality = 0.88;
        console.log('📷 Medium image - will optimize');
      }

      if (shouldCompress) {
        console.log('Original size:', file.size, 'bytes');
        console.log('Target resolution:', targetWidth + 'px width');
        console.log('Target quality:', Math.round(targetQuality * 100) + '%');

        try {
          const compressed = await compressImage(file, targetWidth, targetQuality);
          if (compressed && compressed.size > 0) {
            processedFile = compressed;
            console.log('✅ Optimization successful!');
            console.log('New size:', processedFile.size, 'bytes');
            console.log('Size reduction:', Math.round((1 - processedFile.size / file.size) * 100) + '%');

            // If still too large after compression, try again more aggressively
            if (processedFile.size > 1.5 * 1024 * 1024) {
              console.log('⚠️ Still large, applying aggressive compression...');
              const aggressive = await compressImage(processedFile, 1024, 0.70);
              if (aggressive && aggressive.size > 0 && aggressive.size < processedFile.size) {
                processedFile = aggressive;
                console.log('✅ Aggressive compression successful!');
                console.log('Final size:', processedFile.size, 'bytes');
              }
            }
          } else {
            console.warn('Compression returned invalid file, using original');
          }
        } catch (compressionError) {
          console.warn('Compression failed, using original:', compressionError);
        }
      } else {
        console.log('✓ Image size is optimal (<500KB), no compression needed');
      }

      processedFile = await ensureJpegFile(processedFile);

      // Convert image to base64
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const result = reader.result;
          console.log('Image converted to base64');
          console.log('Base64 length:', result?.length);
          console.log('Base64 prefix (first 100 chars):', result?.substring(0, 100));
          console.log('Image format from base64:', result?.substring(0, 30));
          resolve(result);
        };
        reader.onerror = (error) => {
          console.error('FileReader error:', error);
          reject(error);
        };
        reader.readAsDataURL(processedFile);
      });

      console.log('Starting image search with base64 data');

      // Directly proceed with upload search without cropping
      // setUploadedImage(base64);
      // setShowCropper(true);
      await handleCropComplete(String(base64));

    } catch (error) {
      console.error('Image processing error:', error);
      setSearchError('Failed to process image. Please try again.');
    }
  };

  // COMMENTED OUT: Keep ref in sync for paste handler
  // onImageSelectedRef.current = onImageSelected;

  const handleCropComplete = async (croppedImage) => {
    // Hide the cropper
    setShowCropper(false);
    setUploadedImage(null);

    // Start upload process with visual feedback
    setIsUploading(true);
    setUploadProgress(0);
    setUploadStatus("Processing cropped image...");

    try {
      // Clear previous image results to ensure fresh search
      sessionStorage.removeItem('alibaba_image_results');

      setUploadProgress(10);
      setUploadStatus("Uploading cropped image to search engine...");

      const b64 = String(croppedImage || '');
      const timestamp = Date.now();
      sessionStorage.setItem('alibaba_image_upload_b64', b64);
      sessionStorage.setItem('alibaba_image_timestamp', timestamp.toString());

      // Product mapping helper function
      const tryMap = (products = []) => {
        if (!Array.isArray(products)) return [];

        return products.map((product) => ({
          ...product,
          _id: product.offerId || product.id || Math.random().toString(36).slice(2),
          sku: String(product.offerId || product.id || ''),
          title: product.subjectTrans || product.subject || '',
          sp: Number(product.priceInfo?.price || 0),
          imgUrl: [
            String(
              (product.imageUrl ||
                product.image ||
                product.mainImage ||
                product.productImage ||
                '')
                .replace(/^http:/, 'https:')
            )
          ].filter(Boolean),
          moq: Number(product.minOrderQuantity || 0),
          handling_days: Number(product.detailed_info?.productShippingInfo?.leadTime || 0) || undefined,
          location: 'alibaba',
          month_sold: Number(product.monthSold || 0),
          variations: [],
        }));
      };

      setUploadProgress(40);
      setUploadStatus("Searching for similar products...");

      let mapped = [];
      const imageSearchUrl = process.env.REACT_APP_APIUrl
        ? `${process.env.REACT_APP_APIUrl}admin/get-product-info-by-image`
        : `${process.env.REACT_APP_APIUrl1688}/get-product-info-by-image`;
      const useBackendImageSearch = !!process.env.REACT_APP_APIUrl;
        const token = !useBackendImageSearch ? await fetchToken() : null;
        const imageSearchHeaders = useBackendImageSearch
          ? { 'Content-Type': 'application/json' }
          : { 'Content-Type': 'application/json', 'X-API-Token': token };
      const imagePageSize = parseInt(process.env.REACT_APP_TOTAL_PRODUCTS || '12', 10);
      const imageSearchPayload = { imageBase64: b64, beginPage: 1, pageSize: imagePageSize, country: 'en' };

      try {
        console.log('=== API Call: Image Search ===');
        console.log('Endpoint:', useBackendImageSearch ? 'backend get-product-info-by-image (with tagInfoList)' : 'globalapi get-product-info-by-image');
        console.log('Base64 length being sent:', b64.length);
        console.log('Base64 prefix:', b64.substring(0, 50));

        const response = await fetch(imageSearchUrl, {
          method: 'POST',
          headers: imageSearchHeaders,
          body: JSON.stringify(imageSearchPayload),
        });

        console.log('API Response status:', response.status);
        console.log('API Response headers:', Object.fromEntries(response.headers.entries()));

        const data = await response.json();
        console.log('Parsed API response:', data);

        // Handle new API response structure
        if (data.status === 'success' && data.products) {
          console.log('Products found in response:', data.products.length);

          // Store imageId for pagination API calls
          if (data.imageId) {
            sessionStorage.setItem('alibaba_image_search_imageId', data.imageId);

            // Save image search to search log
            const imageKeyword = `img:${data.imageId}`;
            SearchLogService.saveSearchKeyword(imageKeyword, 'global', 'image-search').catch(err => {
              console.warn('Failed to save image search keyword:', err);
            });
          } else {
            // If no imageId, use a hash of base64 or timestamp as identifier
            const imageHash = `img:${timestamp}`;
            SearchLogService.saveSearchKeyword(imageHash, 'global', 'image-search').catch(err => {
              console.warn('Failed to save image search keyword:', err);
            });
          }

          // Store pagination info for proper pagination handling (align pageSize with env)
          if (data.pagination) {
            sessionStorage.setItem('alibaba_image_search_pagination', JSON.stringify({ ...data.pagination, pageSize: imagePageSize }));
          }

          // Store base64 for fallback pagination (if imageId doesn't work)
          sessionStorage.setItem('alibaba_image_search_base64', b64);

          mapped = tryMap(data.products).slice(0, imagePageSize);
          console.log('Mapped products:', mapped.length);
        } else {
          console.error('API returned unsuccessful response:', data);
        }

      } catch (error) {
        console.error('API Call failed:', error);

        // Fallback: Try with stripped base64 (without data URI prefix)
        if (error.name !== 'AbortError') {
          console.log('Trying fallback with stripped base64...');
          setUploadProgress(60);
          setUploadStatus("Trying alternative format...");

          try {
            const stripped = b64.replace(/^data:[^,]+,/, '');
            console.log('Stripped base64 length:', stripped.length);

            const response2 = await fetch(imageSearchUrl, {
              method: 'POST',
              headers: imageSearchHeaders,
              body: JSON.stringify({ imageBase64: stripped, beginPage: 1, pageSize: imagePageSize, country: 'en' }),
            });

            const data2 = await response2.json();
            console.log('Fallback API response:', data2);

            if (data2.status === 'success' && data2.products) {
              // Store imageId for pagination API calls
              if (data2.imageId) {
                sessionStorage.setItem('alibaba_image_search_imageId', data2.imageId);

                // Save image search to search log
                const imageKeyword = `img:${data2.imageId}`;
                SearchLogService.saveSearchKeyword(imageKeyword, 'global', 'image-search').catch(err => {
                  console.warn('Failed to save image search keyword:', err);
                });
              } else {
                // If no imageId, use a hash of base64 or timestamp as identifier
                const imageHash = `img:${timestamp}`;
                SearchLogService.saveSearchKeyword(imageHash, 'global', 'image-search').catch(err => {
                  console.warn('Failed to save image search keyword:', err);
                });
              }

              // Store pagination info for proper pagination handling
              if (data2.pagination) {
                sessionStorage.setItem('alibaba_image_search_pagination', JSON.stringify({ ...data2.pagination, pageSize: imagePageSize }));
              }

              // Store base64 for fallback pagination (keep full data URI so pagination can reuse it)
              sessionStorage.setItem('alibaba_image_search_base64', b64);

              mapped = tryMap(data2.products).slice(0, imagePageSize);
              console.log('Fallback mapped products:', mapped.length);
            }
          } catch (fallbackError) {
            console.error('Fallback also failed:', fallbackError);
          }
        }
      }

      setUploadProgress(100);
      setUploadStatus("Upload complete! Redirecting to results...");

      console.log('=== Image Upload Complete ===');
      console.log('Total products found:', mapped.length);
      console.log('Navigating to results page...');

      // Small delay to show completion
      setTimeout(() => {
        if (mapped.length) {
          console.log('Storing results in sessionStorage and navigating to ready page');
          sessionStorage.setItem('alibaba_image_results', JSON.stringify(mapped));
          sessionStorage.setItem('alibaba_image_results_timestamp', timestamp.toString());
          navigate(`/collection?ali=ready&category=global&t=${timestamp}`);
        } else {
          console.log('No products found, navigating to upload page');
          navigate(`/collection?ali=upload&category=global&t=${timestamp}`);
        }
        // Reset upload state
        setIsUploading(false);
        setUploadProgress(0);
        setUploadStatus("");
      }, 1000);

    } catch (error) {
      console.error('Image upload error:', error);
      setUploadStatus("Upload failed. Please try again.");
      setTimeout(() => {
        setIsUploading(false);
        setUploadProgress(0);
        setUploadStatus("");
      }, 3000);
    }
  };

  return (
    <div className="searchbar_centered">
      <div className="web_navbar_search">

        {/* Upload Progress Overlay */}
        {isUploading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
          }}>
            <div style={{
              backgroundColor: 'white',
              padding: '30px',
              borderRadius: '12px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
              maxWidth: '400px',
              width: '90%',
              textAlign: 'center'
            }}>
              <div style={{
                width: '60px',
                height: '60px',
                border: '4px solid #f3f3f3',
                borderTop: '4px solid var(--web-primary-color, #3DD0E5)',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 20px'
              }}></div>
              <h3 style={{ margin: '0 0 15px', color: 'var(--web-secondary-color, #004C81)' }}>Uploading Image</h3>
              <p style={{ margin: '0 0 20px', color: 'var(--web-grey-color, #949494)', fontSize: '14px' }}>{uploadStatus}</p>

              {/* Progress Bar */}
              <div style={{
                width: '100%',
                height: '8px',
                backgroundColor: '#f0f0f0',
                borderRadius: '4px',
                overflow: 'hidden',
                marginBottom: '10px'
              }}>
                <div style={{
                  width: `${uploadProgress}%`,
                  height: '100%',
                  backgroundColor: 'var(--web-primary-color, #3DD0E5)',
                  transition: 'width 0.3s ease',
                  borderRadius: '4px'
                }}></div>
              </div>
              <p style={{ margin: 0, color: 'var(--web-dark-grey-color, #6d6d6d)', fontSize: '12px' }}>{uploadProgress}% Complete</p>
            </div>
          </div>
        )}

        <div className="select_wrapper">
          {/* <div className="selected_category_col">
    &nbsp; {selectedCategory} &nbsp;
  </div> */}
          <button defaultValue='Alibaba' value={selectedCategory} onChange={selectCategory}>
            Global
            {/* <option value="All Categories">&nbsp; All Categories &nbsp;</option> */}
            {/* <option value="Alibaba">&nbsp; Global &nbsp;</option> */}

            {/* {Array.isArray(categories) &&
      categories
        .map((category) => {
          const name =
            category?.c_name ||
            category?.name ||
            category?.tagName ||
            category?.title ||
            "";
          return name ? String(name).trim() : "";
        })
        .filter(Boolean)
        .filter((name, idx, arr) => arr.indexOf(name) === idx) // duplicates remove
        .map((name, index) => (
          <option key={index} value={name}>
            &nbsp; {name} &nbsp;
          </option>
        ))} */}
          </button>

          {/* <div>{downVIcon}</div> */}
        </div>


        <form onClick={() => handleActiveInput()} onSubmit={handleProducts}>
          <div style={{ flex: 1, width: '100%' }}>
            <SearchAutocomplete
              ref={inputRef}
              value={searchVal}
              onChange={handleOnChange}
              onSearch={(keyword) => {
                if (keyword) {
                  setSearchVal(keyword);
                  // ✅ FIX: Immediately trigger search natively instead of dispatching to the form
                  executeSearch(keyword);
                }
              }}
              placeholder="Search By Image"
              className="web-search-input"
              fetchSuggestions={SearchAutocompleteService.getSuggestions}
              minChars={2}
              maxSuggestions={6}
              disabled={isSkuSearching}
              suppressSuggestions={
                location.pathname.startsWith("/product-details") ||
                (location.pathname === "/collection" &&
                  searchParams.get("search") != null &&
                  searchVal.trim() === decodeURIComponent(searchParams.get("search") || "").trim())
              }
            />
          </div>
          <input
            type="file"
            accept="image/*,image/heic,image/heif"
            ref={fileInputRef}
            style={{
              position: 'absolute',
              left: '-9999px',
              top: '-9999px',
              width: '1px',
              height: '1px',
              opacity: 0,
              pointerEvents: 'none',
              visibility: 'hidden',
              overflow: 'hidden'
            }}
            onChange={onImageSelected}
            tabIndex={-1}
            aria-hidden="true"
            name="imageUpload"
          />
          {selectedCategory === "global" && (
            <button
              type="button"
              className="web_navbar_search_icon"
              onClick={handleImageSearchClick}
              title="Search by image (Global)"
              disabled={isUploading}
              style={{
                opacity: isUploading ? 0.5 : 1,
                cursor: isUploading ? 'not-allowed' : 'pointer',
                touchAction: 'manipulation',
                WebkitTapHighlightColor: 'transparent',
                userSelect: 'none'
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 3l-1.5 2H5a2 2 0 00-2 2v10a2 2 0 002 2h14a2 2 0 002-2V7a2 2 0 00-2-2h-2.5L15 3H9z" stroke="currentColor" strokeWidth="2" fill="none" />
                <circle cx="12" cy="13" r="4" stroke="currentColor" strokeWidth="2" fill="none" />
              </svg>
            </button>
          )}

          {/* COMMENTED OUT: AliExpress-style Image Search Dropdown (hover functionality) */}
          {/* {showImageDropdown && (
            <div
              className="image-search-dropdown"
              ref={imageDropdownRef}
              onMouseEnter={handleDropdownMouseEnter}
              onMouseLeave={handleDropdownMouseLeave}
            >
              <div className="image-search-dropdown-header">
                <span className="image-search-dropdown-title">Search by image</span>
                <button
                  type="button"
                  className="image-search-dropdown-close"
                  onClick={() => setShowImageDropdown(false)}
                  aria-label="Close"
                >
                  &#10005;
                </button>
              </div>
              <p className="image-search-dropdown-subtitle">
                Find what you love with better prices on Importerr by using an image search
              </p>
              <div
                className={`image-search-dropzone${isDraggingOver ? ' dragging' : ''}`}
                onDragOver={handleDropzoneDragOver}
                onDragLeave={handleDropzoneDragLeave}
                onDrop={handleDropzoneDrop}
              >
                <svg className="image-search-dropzone-icon" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="4" y="8" width="40" height="32" rx="4" stroke="#ccc" strokeWidth="2" fill="none"/>
                  <circle cx="16" cy="20" r="4" stroke="#ccc" strokeWidth="2" fill="none"/>
                  <path d="M4 32l10-10 8 8 6-6 16 16" stroke="#ccc" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <p className="image-search-dropzone-text">Drag an image here</p>
                <span className="image-search-dropzone-or">or</span>
                <button
                  type="button"
                  className="image-search-upload-btn"
                  onClick={handleUploadFromDropdown}
                >
                  Upload a photo
                </button>
              </div>
              <p className="image-search-dropdown-hint">
                *For a quick search hit CTRL+V to paste an image into the search box
              </p>
            </div>
          )} */}
          <button
            type="submit"
            className="web_navbar_search_icon"
            onClick={handleProducts}
            disabled={isUploading || isSkuSearching}
            style={{
              opacity: (isUploading || isSkuSearching) ? 0.5 : 1,
              cursor: (isUploading || isSkuSearching) ? 'not-allowed' : 'pointer'
            }}
          >
            {searchIcon}
          </button>
        </form>

        {/* CSS for spinner animation */}
        <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>

      </div>
      {searchError && (<div className="text-red-500 text-sm mt-1">{searchError}</div>)}
      {isSkuSearching && (<div style={{ position: 'fixed', top: '180px', left: '50%', transform: 'translateX(-50%)', backgroundColor: 'rgba(255,255,255,0.95)', display: 'flex', alignItems: 'center', gap: '12px', zIndex: 1000, borderRadius: '12px', padding: '12px 16px', minWidth: '260px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', border: '1px solid #e5e7eb', }}>
        <div style={{ width: '22px', height: '22px', border: '3px solid #e5e7eb', borderTop: '3px solid #3DD0E5', borderRadius: '50%', animation: 'spin 1s linear infinite', }} />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <strong style={{ margin: 0, color: '#004C81', fontSize: '14px' }}>Loading product</strong>
          <span style={{ margin: 0, color: '#6b7280', fontSize: '12px' }}>Searching by SKU… please wait</span>
        </div>
      </div>
      )}
    </div>
  );
}